module.exports = __webpack_public_path__ + "static/media/arrow-next.aa2677cb.svg";